var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isEnvStagging)?_c('v-chip',{staticClass:"warning d-flex justify-center black--text rounded-10"},[_vm._v(" Ambiente de testes ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }